import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-status',
  standalone: true,
  templateUrl: './rt-icon-status.component.html',
  styleUrls: ['./rt-icon-status.component.scss']
})
export class RtIconStatusComponent {
  private readonly defaultConfig = {
    width: 17,
    height: 17
  };

  @Input() width: number | string = this.defaultConfig.width;
  @Input() height: number | string = this.defaultConfig.height;
}
